import { registerSingleton } from '@/infrastructure/container';

import { Analytics, TOKEN_IAnalytics } from '@/services/Analytics';
import { AppBus, TOKEN_IAppBus } from '@/services/AppBus';
import { BookParser, TOKEN_IBookParser } from '@/services/BookParser';
import { DomKeyboard, TOKEN_IDomKeyboard } from '@/services/DomKeyboard';
import { DomLocale, TOKEN_IDomLocale } from '@/services/DomLocale';
import { DomTheme, TOKEN_IDomTheme } from '@/services/DomTheme';
import { I18n, TOKEN_II18n } from '@/services/i18n/I18n';
import { IdGen, TOKEN_IIdGen } from '@/services/IdGen';
import { LocalData, TOKEN_ILocalData } from '@/services/LocalData';
import { LocalStorage, TOKEN_ILocalStorage } from '@/services/LocalStorage';
import { Logger, TOKEN_ILogger } from '@/services/Logger';
import { TTSService, TOKEN_ITTSService } from '@/services/TTSService';
import { KokoroTTSService } from '@/services/tts/KokoroTTSService';
import { KokoroWorkerSynth } from '@/services/tts/KokoroWorkerSynth';
import { WebAudioSink } from '@/services/tts/WebAudioSink';
import { TTSRouter } from '@/services/tts/TTSRouter';

import { AppStore, TOKEN_AppStore } from '@/views/AppStore';
import { PlayerStore, TOKEN_PlayerStore } from '@/views/PlayerStore';
import { ThemeStore, TOKEN_ThemeStore } from '@/views/ThemeStore';
import { ToastStore, TOKEN_ToastStore } from '@/views/ToastStore';
import { UploadStore, TOKEN_UploadStore } from '@/views/UploadStore';

// The ONLY place register* is called. The dependency graph is visible here.
export function ud_di(): void {
  registerSingleton(TOKEN_ILogger, () => new Logger());
  registerSingleton(TOKEN_IAppBus, (r) => new AppBus(r(TOKEN_ILogger)));
  registerSingleton(TOKEN_IIdGen, () => new IdGen());
  registerSingleton(TOKEN_ILocalStorage, () => new LocalStorage());
  registerSingleton(TOKEN_IDomTheme, () => new DomTheme());
  registerSingleton(TOKEN_ILocalData, (r) => new LocalData(r(TOKEN_ILogger)));
  registerSingleton(TOKEN_IDomKeyboard, (r) => new DomKeyboard(r(TOKEN_IAppBus)));
  // The router owns both engines but constructs nothing heavy: the Kokoro worker and its ~88MB
  // model download are deferred until the user actually switches to the Kokoro voice.
  registerSingleton(
    TOKEN_ITTSService,
    () => new TTSRouter(new TTSService(), new KokoroTTSService(new KokoroWorkerSynth(), new WebAudioSink())),
  );
  registerSingleton(TOKEN_IBookParser, (r) => new BookParser(r(TOKEN_ILogger)));
  registerSingleton(TOKEN_IAnalytics, (r) => new Analytics(r(TOKEN_ILogger)));
  registerSingleton(TOKEN_IDomLocale, () => new DomLocale());
  registerSingleton(TOKEN_II18n, (r) => new I18n(r(TOKEN_IDomLocale), r(TOKEN_ILogger)));

  registerSingleton(TOKEN_AppStore, (r) => new AppStore(r(TOKEN_IDomKeyboard)));
  registerSingleton(
    TOKEN_ThemeStore,
    (r) => new ThemeStore(r(TOKEN_IAppBus), r(TOKEN_ILocalStorage), r(TOKEN_IDomTheme)),
  );
  registerSingleton(TOKEN_ToastStore, (r) => new ToastStore(r(TOKEN_IAppBus), r(TOKEN_IIdGen)));
  registerSingleton(
    TOKEN_UploadStore,
    (r) =>
      new UploadStore(
        r(TOKEN_IAppBus),
        r(TOKEN_IBookParser),
        r(TOKEN_ILocalData),
        r(TOKEN_IAnalytics),
        r(TOKEN_II18n),
        r(TOKEN_ILogger),
      ),
  );
  registerSingleton(
    TOKEN_PlayerStore,
    (r) =>
      new PlayerStore(
        r(TOKEN_IAppBus),
        r(TOKEN_ITTSService),
        r(TOKEN_ILocalData),
        r(TOKEN_ILocalStorage),
        r(TOKEN_IAnalytics),
        r(TOKEN_II18n),
        r(TOKEN_ILogger),
      ),
  );
}
